import { P2GBox, P2GButton, P2GCard, P2GCardContent, P2GStack, P2GText, P2GTextBox } from '@parcel2go/core-ui';
import { useTenant } from '@parcel2go/npm-p2g-app';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { TranslationNamespaces } from '~/lib/constants';
import { PublicSettings } from '~/lib/ui-serverless-settings';

export default function AnotherParcel() {
  const { t } = useTranslation(TranslationNamespaces.TRACKING);
  const navigate = useNavigate();
  const params = useParams();
  const { settings } = useTenant();
  const [value, setValue] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');

  const helperText = t('SEARCH_TEXTBOX_HELPER', 'e.g. {{prefix}}12345678', {
    prefix: settings[PublicSettings.PREFIX]
  });

  function handleTrackingNumberChange(trackingNumber: string) {
    if (trackingNumber.length === 0) {
      setErrorMessage(t('SEARCH_TEXTBOX_ERROR_EMPTY', 'Please enter a tracking number.'));
    } else {
      setErrorMessage('');
    }
    setValue(trackingNumber);
  }
  function onSearchClick(value: string) {
    if (value.length === 0) {
      setErrorMessage(t('SEARCH_TEXTBOX_ERROR_EMPTY', 'Please enter a tracking number.'));
      return;
    }

    navigate(`${params.prefix ? `/${params.prefix}` : ''}/tracking/${encodeURIComponent(value)}`);
  }

  return (
    <P2GCard sx={{ height: '100%' }} variant="outlined">
      <P2GCardContent sx={{ height: '100%' }}>
        <P2GStack spacing={2} sx={{ height: '100%', justifyContent: 'space-between' }}>
          <P2GBox>
            <P2GText>
              <Trans
                t={t}
                i18nKey="RESULT_INFORMATION_CARDS_TRACK_ANOTHER_TITLE"
                defaults="Sent another parcel? Enter the tracking number below:"
              />
            </P2GText>
          </P2GBox>
          <P2GBox>
            <P2GTextBox
              id="txtTrackingNumber"
              onChange={handleTrackingNumberChange}
              value={value}
              label={helperText}
              error={!!errorMessage}
              helperText={errorMessage}
            />
          </P2GBox>
          <P2GBox>
            <P2GButton variant="tertiary" onClick={() => onSearchClick(value)}>
              <Trans t={t} i18nKey="RESULT_INFORMATION_CARDS_TRACK_ANOTHER_BUTTON" defaults="Track Parcel" />
            </P2GButton>
          </P2GBox>
        </P2GStack>
      </P2GCardContent>
    </P2GCard>
  );
}
